__turbopack_context__.v({
  "className": "manrope_2432a73c-module__eu8uhG__className",
  "variable": "manrope_2432a73c-module__eu8uhG__variable",
});
